import React, { useRef } from 'react';
import { eventStreamService } from 'core-roblox-utilities';
import { WithTranslationsProps } from 'react-utilities';
import {
  TGameData,
  TOmniRecommendationSort,
  TGetFriendsResponse
} from '../common/types/bedev1Types';
import { GameCarousel } from '../common/components/GameCarousel';
import { TOnTileClick } from '../common/components/GameTileUtils';
import { buildGameDetailUrl } from '../common/utils/browserUtils';
import eventStreamConstants, { PageContext } from '../common/constants/eventStreamConstants';
import useGameImpressionCarouselTracker from '../common/hooks/useGameImpressionCarouselTracker';

type THomePageGameCarouselGameCarouselProps = {
  positionId: number;
  gameData: TGameData[];
  sort: TOmniRecommendationSort;
  friendsPresence: TGetFriendsResponse[];
  translate: WithTranslationsProps['translate'];
};

export const HomePageCarousel = ({
  translate,
  friendsPresence,
  gameData,
  sort,
  positionId
}: THomePageGameCarouselGameCarouselProps): JSX.Element => {
  const carouselRef = useRef<HTMLDivElement>(null);
  const tileRef = useRef<HTMLDivElement>(null);
  const onTileClick: TOnTileClick = (data, id) => {
    const gameDetailReferralParams = eventStreamConstants.gameDetailReferral({
      pid: data.placeId,
      ad: data.isSponsored,
      pos: id,
      gameSetTargetId: sort.TopicId,
      pg: PageContext.HomePage
    });
    eventStreamService.sendEvent(...gameDetailReferralParams);
    window.open(buildGameDetailUrl(data.placeId, data.name), '_self');
  };

  useGameImpressionCarouselTracker(carouselRef, tileRef, gameData, {
    sortPos: positionId,
    gameSetTargetId: sort.TopicId,
    pg: PageContext.HomePage
  });

  return (
    <GameCarousel
      ref={carouselRef}
      tileRef={tileRef}
      gameData={gameData}
      friendData={friendsPresence}
      onTileClick={onTileClick}
      translate={translate}
    />
  );
};

export default HomePageCarousel;
